import PostsFeed from './PostsFeed';
export default PostsFeed;
